import { app } from '../../../../../app';
import { Controller } from './copy-accounts.controller';

app.component('companyUserDirectoriesManageUserCopyAccounts', {
    bindings: {
        accounts: '<',
        accountsForCompanyUser: '<',
        companyId: '<',
        companyUser: '<',
    },
    controller: Controller,
    templateUrl: require('./copy-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/copy-accounts/copy-accounts.component.js